import styles from "./AccountForms.module.scss"
import { usePolyglot } from "src/contexts"

interface Props {
  variant: "required" | "optional";
}

export function RequirementLabel(props: Props) {
  const { variant } = props

  const polyglot = usePolyglot()
  const text = polyglot.t(`components.account_forms.requirement_label.${variant}`)

  return (
    <div className={styles.requirementLabel}>
      {text}
    </div>
  )
}
